import {PaginatedResponse, PropertyFull} from '../../types';
import {fetchData} from "../data-service";

// Функция для создания ключа кэша
export const createCacheKey = (propA: PropertyFull, propB: PropertyFull): string => {
    // Генерируем ключи для обоих свойств
    const keyA = `${propA.propertyTypeId}-${propB.propertyTypeId}`;
    const keyB = `${propB.propertyTypeId}-${propA.propertyTypeId}`;

    // Сортируем ключи, чтобы независимо от порядка свойств ключ был одинаковым
    return [keyA, keyB].sort().join(':');
};

/**
 * Универсальная функция для постраничного получения данных.
 *
 * @param baseUrl - базовый URL запроса, без параметров пагинации (например, `${DOCUMENT_TYPES_ENDPOINT}`)
 * @param pageSize - количество элементов на страницу
 * @param processItems - callback, который вызывается для обработки полученных элементов
 */
export async function fetchPaginatedData<T>(
    baseUrl: string,
    pageSize: number,
    processItems: (items: T[]) => void
): Promise<void> {
    let page = 1;
    while (true) {
        const url = `${baseUrl}?page=${page}&pageSize=${pageSize}`;
        const response = await fetchData<PaginatedResponse<T>>(url);

        // Обрабатываем полученные элементы
        processItems(response.items);

        // Если получено меньше элементов, чем ожидается для полной страницы, значит, достигли конца
        if (response.items.length < pageSize) {
            break;
        }
        page++;
    }
}
